import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-materialize";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import LiveSearch from "../pages/commanPage/Search/LiveSearch";
import NotificationHomeComponent from "../pages/commanPage/notification/NotificationHomeComponent";
import { getOrganizationDetails } from "../redux/action/organization";
import { capitalizeFirstLetter } from "../helpers/helpers";
import { logOut } from "../redux/action/auth";

function Header({ setOpenAside, openAside, userInfo }) {
  const navigate = useNavigate()
  const isSmallMobile = useMediaQuery({ query: "(max-width: 450px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1224px)" });
  // const isDastop = useMediaQuery({ query: "(max-width: 1500px)" });
  const { accountType } = useSelector((state) => state?.account);
  const [logout, setLogout] = useState(false);
  const { profile } = useSelector((state) => state.profileStore);

  const dispatch = useDispatch();
  const { organization, loadings } = useSelector(
    (pre) => pre?.organizationDetails
  );

  const openAuctionPopup = () => {
    // navigate(`/live-auctions`)
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    const width = Math.floor(screenWidth * 0.9);
    const height = Math.floor(screenHeight * 0.9);

    const left = (screenWidth - width) / 2;
    const top = (screenHeight - height) / 2;

    const auctionUrl = `/live-auctions`;

    const popupWindowInAuction = window.open(
      auctionUrl,
      "_blank",
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`
    );

    if (popupWindowInAuction) {
      popupWindowInAuction.focus();
    } else {
      alert("Please allow popups for this website.");
    }
  };

  useEffect(() => {
    if (profile?.organization) {
      dispatch(getOrganizationDetails(profile?.organization));
    }
  }, [dispatch, profile]);

  return (
    <header className="flex align-center space-between white full-width  header ph-1">
      <div className="flex align-center  ">
        <div
          className={
            openAside ? "open-menu-icon pointer" : "menu-icon p-1 pointer"
          }
          onClick={() => setOpenAside(!openAside)}
        >
          {openAside ? (
            <span className="material-symbols-outlined menu-icon icon hover ml-2    ">
              close
            </span>
          ) : (
            <span className="material-symbols-outlined menu-icon icon hover ">
              segment
            </span>
          )}
        </div>
        {!isSmallMobile && <div className="company-profile flex mh-1  align-center ">
          <div className="flex align-center gap-1 ml-1">
            <img
              src="/images/company-placeholder.png"
              style={{
                width: "50px",
                height: "50px",
              }}
              alt="company-logo"
            />
            {!isMobile && (
              <div>
                <h5 className="margin-0px">
                  {loadings ? (
                    <Skeleton width={200} />
                  ) : (
                    organization?.organizationName
                  )}
                </h5>

                <p className="small-text grey-text ">
                  Welcome to our auction platform
                </p>
              </div>
            )}
          </div>
        </div>}
      </div>
      <div className="valign-wrapper align-center ">
        {!isLaptop && <LiveSearch />}
        {accountType !== "industry" && (
          <img
            src="/images/liveLogo.gif"
            width="250px"
            height="120px"
            alt="notification"
            className="pointer"
            style={{ marginRight: "-40px", paddingTop: "5px" }}
            onClick={() => openAuctionPopup()}
          />
        )}

        <NotificationHomeComponent />
        {!isLaptop && (
          <Dropdown
            id="prifile_headers"
            options={{
              alignment: "right",
            }}
            trigger={
              <div
                className="user-profile flex align-center mr-1"
                // style={{ minWidth: "250px" }}
              >
                {!isLaptop ? (
                  <div className="flex align-center gap-1 ">
                    <img
                      style={{ border: "1px solid purple" }}
                      className="circle"
                      width={"40px"}
                      height={"40px"}
                      src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                      alt="profile "
                    />
                    {loadings ? (
                      <Skeleton width={200} />
                    ) : (
                      <span>
                        <b className="semi-bold">{profile?.name}</b>
                        <p className="small-size grey-text ">
                          {profile?.email}
                        </p>
                      </span>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            }
            className="user-profile-drop-down "
          >
            <Link to="/profile">
              <div className="flex ml-1 gap-1 ">
                <span className="material-symbols-outlined purple-text">
                  manage_accounts
                </span>
                <p className="semi-bold purple-text ">Account Setting</p>
              </div>
            </Link>
            <span>
              <div
                className="flex ml-1 gap-1"
                href="#modal1"
                onClick={() => setLogout(!logout)}
              >
                <span className="material-symbols-outlined purple-text">
                  logout
                </span>
                <p className="semi-bold purple-text ">Logout </p>
              </div>
              <Modal
                actions={[]}
                id="modal1"
                open={logout}
                options={{
                  onCloseEnd: () => setLogout(false),
                }}
              >
                <b className="normal-size">Confirm Logout </b>
                <p className="semi-bold">Are you sure you want to logout?</p>
                <div className="flex justify-end gap-1">
                  <button
                    className="green btn-small "
                    onClick={() => dispatch(logOut())}
                  >
                    Yes
                  </button>

                  <button
                    className="red btn-small"
                    onClick={() => setLogout(false)}
                  >
                    No
                  </button>
                </div>
              </Modal>
            </span>
          </Dropdown>
        )}
      </div>
    </header>
  );
}

export default Header;
